<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>In memory of my late husband, IAN, who enjoyed reading <em>The Pretty Girls</em> chapter by chapter as I wrote them and who had always encouraged my writing.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?700d1ea8